import { useMutation } from '@apollo/client'
import { EventPayment, EventPaymentVariables } from '../../types'
import { CREATE_EVENT_PAYMENT } from './operations'

export const useCreateEventPayment = () =>
  useMutation<EventPayment, EventPaymentVariables>(CREATE_EVENT_PAYMENT)
